export default __webpack_public_path__ + "static/media/laptop-min.fec759e7.png";